import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';
import { NavLink } from 'react-router-dom';
import { SystemConstants } from '@datatox-bi/util';

function ResponsiveAppBar() {
    const isHomologacao = process.env.REACT_APP_ENV === 'homologacao';
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const svgURL = process.env.PUBLIC_URL + '/logo_abracit_sigla.svg';

    return (
        <>
            {isHomologacao && (
                <Alert severity="warning" sx={{ borderRadius: 0, justifyContent: 'center' }}>
                    <Typography variant="body2" fontWeight="bold" sx={{ marginTop: '-5px', marginBottom: '-15px' }}>
                        {SystemConstants.Strings.ambienteHomologacao}
                    </Typography>
                    <Typography variant="caption">{SystemConstants.Strings.disclaimerHomologacao}</Typography>
                </Alert>
            )}
            <AppBar position="static" sx={{ backgroundColor: '#f3f3f3' }}>
                <Container maxWidth="xl">
                    <Toolbar variant="dense">
                        <Box component={NavLink} to="/" sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
                            {/* Exibindo o SVG utilizando uma tag img */}
                            <img src={svgURL} alt="Abracit" width={180} />
                        </Box>
                        <Typography
                            variant="h6"
                            noWrap
                            component="span"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                // letterSpacing: '.3rem',
                                color: 'black',
                                textDecoration: 'none',
                            }}
                        >
                            {SystemConstants.Strings.tituloSistema}
                        </Typography>

                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="black"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {SystemConstants.MetaRoutes.map((metaRoute, index) => (
                                    <NavLink key={index} to={metaRoute.href} style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <MenuItem onClick={handleCloseNavMenu}>
                                            <Typography textAlign="center">{metaRoute.title}</Typography>
                                        </MenuItem>
                                    </NavLink>
                                ))}
                            </Menu>
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
                            {/* Exibindo o SVG utilizando uma tag img */}
                            <img src={svgURL} alt="My Icon" width={150} />
                        </Box>
                        <Typography
                            variant="h5"
                            noWrap
                            component="span"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'flex', md: 'none' },
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'black',
                                textDecoration: 'none',
                            }}
                        >
                            {SystemConstants.Strings.tituloSistema}
                        </Typography>
                        <Box sx={{ flexGrow: 3, justifyContent: 'flex-end', display: { xs: 'none', md: 'flex' } }}>
                            <Button component={NavLink} to="/" sx={{ my: 2, color: 'primary', display: 'block' }}>
                                {SystemConstants.Strings.paginas.home}
                            </Button>
                            <Button onClick={handleClick} sx={{ my: 2, color: 'primary', display: 'block' }}>
                                {SystemConstants.Strings.paineis}
                            </Button>
                            <Menu
                                id="atendimento-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                            >
                                {SystemConstants.MetaRoutes.map((metaRoute, index) => (
                                    <MenuItem key={index} onClick={handleClose}>
                                        <NavLink to={metaRoute.href} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            {metaRoute.title}
                                        </NavLink>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    );
}
export default ResponsiveAppBar;
